import { render, staticRenderFns } from "./EditorPopUp.vue?vue&type=template&id=5251a08f&scoped=true"
import script from "./EditorPopUp.vue?vue&type=script&lang=js"
export * from "./EditorPopUp.vue?vue&type=script&lang=js"
import style0 from "./EditorPopUp.vue?vue&type=style&index=0&id=5251a08f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251a08f",
  null
  
)

export default component.exports